<script setup>
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import HoursWidget from './HoursWidget.vue';
import iconPhone from '@client/svg/phone.svg?raw';

let rootData = inject('rootData');
const { t } = useI18n();

</script>

<template>
    <section class="hero">
        <div class="hero__inner">
            <div v-if="rootData.view?.logo" class="hero__logo">
                <img :src="rootData.view.logo" data-name="shop-logo" :alt="t('a11y.businessLogo')">
            </div>
            <div class="hero__meta">
                <div v-show="rootData?.name" class="hero__title" data-name="shop-name">{{ rootData.name }}</div>
                <address v-show="rootData?.address" class="hero__addr" data-name="shop-address">
                    <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path
                            d="M215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2a30.21 30.21 0 0 0 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
                            fill="currentColor"></path>
                    </svg>
                    {{ rootData.address?.address ? rootData.address?.address + ', ' : '' }} {{ rootData.address?.city
                    }}, {{ rootData.address?.state }} {{ rootData.address?.zip }}
                </address>
                <a v-show="rootData?.phone" class="hero__phone" :href="'tel:' + rootData?.phone">
                    <div class="iconw" v-html="iconPhone"></div>
                    <span>
                        {{ rootData?.phone }}
                    </span>
                </a>
                <div class="hero__hours">
                    <HoursWidget :timezone="rootData?.timezone" :oh="rootData?.address?.oh"/>
                </div>
            </div>
        </div>
        <img v-if="rootData.view.bg && rootData.view.bg.src" :src="rootData.view.bg.src" class="hero__bg" :alt="t('a11y.bgImage')">
    </section>
</template>

<style lang="scss">
.hero {
    position: relative;
    overflow: hidden;
    padding: 2rem;
    // margin-bottom: 1rem;
    color: var(--text-secondary);
    
    @media (min-width: 1280px) {
        // margin-bottom: 1.5rem;
    }

    &__inner {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        position: relative;
        text-align: center;
        padding: 1.5rem;
        border-radius: 0.625rem;
        margin: 0 auto;
        max-width: 360px;
        background-color: #ffffff;
        box-shadow: 0 0.125rem 0.625rem -0.1875rem var(--text-secondary);
    }

    &__bg {
        -o-object-fit: cover;
        object-fit: cover;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
    }

    &__meta {
        text-align: left;
    }

    &__title {
        font-size: 1.125rem;
        line-height: 1.6;
        font-weight: 500;
        text-align: center;
        color: var(--text-primary);
        
        @media (min-width: 1280px) {
            line-height: 1.4;
            font-size: 1.375rem;
            font-weight: 600;
        }
    }

    &__addr,
    &__phone,
    &__hours {
        line-height: 1.6;
        font-size: 0.875rem;
        font-style: normal;
        min-height: 1.5rem;
    }

    &__phone {
        cursor: pointer;
        color: inherit;
        display: inline-flex;
        align-items: center;

        .iconw {
            margin-right: 0.375rem;
        }
        
        span {
            text-decoration: underline;
        }
    }

    &__logo {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.5rem;
        overflow: hidden;
        margin: 0.5rem auto 1.125rem;
        width: 100%;
        max-width: 120px;
        height: auto;
        max-height: 120px;
        width: auto;
        
        @media (min-width: 1280px) {
            margin: 1.5rem auto 1rem;
        }

        img {
            max-width: 100%;
            height: auto;
        }
    }
}
</style>
